
<div *ngIf="!pdf">
    <button type="button" mat-raised-button color="accent" (click)="fileSelector.click()">
        Importer un fichier
        </button>
        <input hidden #fileSelector type="file" (change)="handleFileInput($event.target.files[0])" accept=".pdf">
</div>
<app-pdf-viewer [pdf]="pdf" *ngIf="pdf">
    
</app-pdf-viewer>